import Component from '@glimmer/component';
import { t } from 'ember-intl';
import Icon from 'madow-tech/components/icon';
import SpaceCard from 'madow-tech/components/space-card';
import revealOnScroll from 'madow-tech/modifiers/reveal-on-scroll';
import mult from 'madow-tech/helpers/mult';

export default class ServicesGrid extends Component {
  get services() {
    return [
      {
        titleKey: 'services.teamAugmentation.title',
        bodyKey: 'services.teamAugmentation.body',
        points: [
          'services.teamAugmentation.point1',
          'services.teamAugmentation.point2',
          'services.teamAugmentation.point3',
        ],
        icon: 'svg-users',
        animation: 'icon-pulse',
      },
      {
        titleKey: 'services.mvp.title',
        bodyKey: 'services.mvp.body',
        points: [
          'services.mvp.point1',
          'services.mvp.point2',
          'services.mvp.point3',
        ],
        icon: 'svg-flask',
        animation: 'icon-pulse',
      },
      {
        titleKey: 'services.endToEnd.title',
        bodyKey: 'services.endToEnd.body',
        points: [
          'services.endToEnd.point1',
          'services.endToEnd.point2',
          'services.endToEnd.point3',
        ],
        icon: 'svg-wrench',
        animation: 'icon-rotate',
      },
      {
        titleKey: 'services.custom.title',
        bodyKey: 'services.custom.body',
        points: [
          'services.custom.point1',
          'services.custom.point2',
          'services.custom.point3',
        ],
        icon: 'svg-workflow',
        animation: 'icon-flow',
      },

      {
        titleKey: 'services.qa.title',
        bodyKey: 'services.qa.body',
        points: [
          'services.qa.point1',
          'services.qa.point2',
          'services.qa.point3',
        ],
        icon: 'svg-shield-check',
        animation: 'icon-shield',
      },
      {
        titleKey: 'services.mobile.title',
        bodyKey: 'services.mobile.body',
        points: [
          'services.mobile.point1',
          'services.mobile.point2',
          'services.mobile.point3',
        ],
        icon: 'svg-rocket',
        animation: 'icon-launch',
      },
    ];
  }

<template>
  <section id="services" class="py-16 md:py-28">
    <div class="mx-auto max-w-7xl px-4">
      <h2 class="text-3xl md:text-4xl font-bold mb-4">{{t "services.title"}}</h2>
      <p class="mt-0 mb-12 md:mb-16 max-w-3xl text-zinc-300 text-base md:text-lg">{{t "services.intro"}}</p>
      <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 md:gap-6">
        {{#each this.services as |s i|}}
          <div
            class="flex justify-stretch w-full"
            {{revealOnScroll animation="fade-up" delay=(mult i 50)}}
          >
            <SpaceCard @variant="v2" @hasHoverEffect={{true}} class="w-full">
              <article class="flex flex-col">
                <div
                  class="inline-flex items-center gap-6 rounded-xl bg-mars-900/30 pr-3 py-1 text-rose-100"
                >
                  <Icon
                    @name={{s.icon}}
                    @svgClass="h-6 w-6 {{s.animation}}"
                    class="!drop-shadow-rose-200/80 !drop-shadow-[0_0_5px]"
                  />
                  <h3 class="text-xl font-medium display">{{t s.titleKey}}</h3>
                </div>

                <p class="mt-4 text-sm text-zinc-300 flex-1">{{t s.bodyKey}}</p>
                <ul class="mt-4 space-y-2 text-sm text-zinc-300">
                  {{#each s.points as |pointKey|}}
                    <li class="flex items-center gap-2">
                      <span class="h-1.5 w-1.5 rounded-full bg-rose-300"></span>
                      {{t pointKey}}
                    </li>
                  {{/each}}
                </ul>
              </article>
            </SpaceCard>
          </div>
        {{/each}}
      </div>
    </div>
  </section>
</template>
